import type { StationFeature } from "types/stations" // Remplace StationsInfo
import React, { SetStateAction, useEffect, useState } from "react"
import {
    TextField,
    List,
    ListItemAvatar,
    ListItemText,
    ListItemButton,
    Typography,
    ListItem,
} from "@mui/material"
import { Card, InputAdornment } from "@mui/material"
import StationAvailable from "./utils/icons/Icon_Map_Disponible.svg"
import searchIcon from "./utils/icons/UI_searchIcon.svg"
import { Box } from "@mui/system"

interface StationListProps {
    stationSource: StationFeature[]
    handleStationClick: (station: StationFeature | undefined) => void
}

const StationList: React.FC<StationListProps> = ({
    stationSource,
    handleStationClick,
}) => {
    const [searchTerm, setSearchTerm] = useState("")
    const [searchResults, setSearchResults] = useState<StationFeature[]>([])

    const handleChange = (event: {
        target: { value: SetStateAction<string> }
    }) => {
        setSearchTerm(event.target.value)
    }

    useEffect(() => {
        const results = stationSource.filter(
            (feature) =>
                feature.properties.name
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) ||
                feature.properties.address
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
        )
        setSearchResults(results)
    }, [searchTerm, stationSource])

    return (
        <Card
            sx={{
                padding: "25px",
                width: "100%",
                height: "100%",
                borderRadius: "20px",
            }}
        >
            <TextField
                data-testid="Search"
                type="text"
                label="Filtrer les stations"
                placeholder="Filtrer par nom, adresse, ..."
                value={searchTerm}
                onChange={handleChange}
                variant="filled"
                sx={{ width: "100%", borderRadius: "4px" }}
                slotProps={{
                    input: {
                        sx: { backgroundColor: 'grey.100' },
                    },
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment
                            position="start"
                            sx={{ marginBottom: '15px' }}
                        >
                            <img src={searchIcon} alt="searchIcon" />
                        </InputAdornment>
                    ),
                }}
            />
            <List
                data-testid="List"
                sx={{ maxHeight: "100%", width: "100%", overflow: "auto" }}
            >
                {searchResults.map((feature, idx) => (
                    <ListItemButton
                        data-testid="ListItemButton"
                        key={idx}
                        onClick={() => handleStationClick(feature)}
                        sx={{
                            borderTop: "1px solid",
                            borderColor: "grey.200",
                            padding: 0,
                        }}
                    >
                        <ListItem
                            data-testid="ListItem"
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                            secondaryAction={
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: 0,
                                        marginBottom: "2.5rem",
                                    }}
                                >
                                    {/* Contenu optionnel ici */}
                                </Box>
                            }
                        >
                            <ListItemAvatar
                                sx={{ marginBottom: "auto", marginTop: "10px" }}
                            >
                                <img src={StationAvailable} alt="mapMarker" />
                            </ListItemAvatar>
                            <ListItemText
                                disableTypography
                                primary={
                                    <Typography
                                        component={"span"}
                                        variant="title"
                                    >
                                        {feature.properties.name}{" "}
                                    </Typography>
                                }
                                secondary={
                                    <>
                                        <Typography
                                            component={"span"}
                                            variant="bodySmall"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                color: "grey.600",
                                                marginTop: "4px",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {feature.properties.address}{" "}
                                            {/* Accès via properties */}
                                        </Typography>
                                    </>
                                }
                            />
                        </ListItem>
                    </ListItemButton>
                ))}
            </List>
        </Card>
    )
}

export default StationList
